<template>
  <div>
    <v-card class="mb-6">
      <v-card-title class="blue white--text">
        Secure report sharing
        <v-spacer />
        <v-btn
          color="white"
          text
          @click="$emit('hide')"
        >
          Hide <v-icon right>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="blue white--text">
        Allow others to view this report by sharing to their email address.
        <br>Only you can see this! No one else will be able to control or see who this report is shared with.
      </v-card-text>
      <v-simple-table class="transparent">
        <thead>
          <tr>
            <th>Email</th>
            <th class="text-center">
              Views
            </th>
            <th width="10">
              Remove
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="share in filteredShares"
            :key="share.id"
          >
            <td>{{ share.email }}</td>
            <td class="text-center">
              {{ views[share.id] || 0 }}
            </td>
            <td width="10">
              <SiDeleteButton 
                title="Remove access?"
                delete-button-text="Remove" 
                :message="`Are you sure you want to remove access to this report for ${share.email}?`"
                @delete="unshare(share.id)" 
              />
            </td>
          </tr>
          <tr v-if="filteredShares.length === 0">
            <td
              class="caption font-italic grey--text"
              colspan="3"
            >
              This report has not been shared
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-divider />
      <v-card-actions>
        <div
          v-if="error"
          class="error--text caption"
        >
          <v-icon
            color="error"
            left
          >
            error
          </v-icon> {{ error }}
        </div>
        <v-spacer />
        <v-btn
          color="blue white--text"
          depressed
          @click="dialog = true"
        >
          Add
        </v-btn>
      </v-card-actions>
    </v-card>


    <v-dialog
      v-model="dialog"
      max-width="500"
    >
      <v-card>
        <v-card-title>Share to</v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            @submit.prevent
          >
            <SiInputText
              v-model="email"
              label="Email address"
              name="email"
              outlined
              validate-on-blur
              required
              :rules="[_ruleEmail()]"
            />
            <SiInputTextarea
              v-model="message"
              label="Message"
              name="message"
              hint="Add a message so the recipient knows why you have shared this report"
              outlined
            />
          </v-form>
          <div class="caption">
            <v-icon>info</v-icon> Your name will be included in the email sent to the recipient.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="!loading"
            color="grey"
            text
            @click="closeDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue white--text"
            :loading="loading"
            @click="share"
          >
            Share
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import helpers from '@/mixins/helpers'
import axios from 'axios'
import binder from '@/mixins/binder'
import validations from '@/mixins/validations'
import { auth  } from '@/plugins/firebase'

  export default {
    mixins: [ binder, validations, helpers ],
    props: {
      sharing: Object,
      calculatorId: String, 
      calculationId: String,
    },
    data: () => ({
      shares: {},
      views: {},
      error: null,
      email: '',
      message: '',
      dialog: false,
      loading: false
    }),
    computed: {
      ...mapGetters(['_user', '_reportIsAdmin', '_reportAdminToken']),
      filteredShares () {
        return this._sortObject(this.shares).filter(s => s.active)
      }
    },
    watch: {
      sharing: {
        handler: function (v) {
          this.shares = v.shares
        }, 
        deep: true,
        immediate: true
      },
      shares (v) {
        this.$emit('update:sharing', {...this.sharing, shares:v})
      },
      dialog () {
        this.email = ''
        this.message = ''        
      }
    },
    beforeMount (){
      this.$bindRtdb('views', `calculations/${this.calculatorId}/${this.calculationId}/sharing/views`)
      // this.$bindxxx(rtdb.ref(`calculations/${this.calculatorId}/${this.calculationId}/sharing/views`), 'views')
    },
    methods: {
      async share () {
        if (!this.$refs.form.validate()) return 

        this.loading = true
        const { sharing: { token }, calculatorId, calculationId, email, message } = this
        await this.sendRequest('add', { token, calculatorId, calculationId, email, message})
        this.loading = false
        this.closeDialog()
      },
      async unshare (id) {
        const { sharing: { token }, calculatorId, calculationId } = this
        this.shares[id].active = false
        await this.sendRequest('remove', { token, calculatorId, calculationId, shareId: id })
      },
      async sendRequest (action, requestData) {
        this.error = null
        try {
          const { calculatorId, calculationId }  = requestData
          const url = `${process.env.VUE_APP_API_URL}/report/${calculatorId}/${calculationId}/share/${action}?ts=${Number(new Date())}` // add time into query string as the browser caches the CORS resopnes. This forces it to do a fresh OPTIONS.
          
          const userToken = await auth.currentUser.getIdToken()

          let token = this._reportIsAdmin ? this._reportAdminToken : userToken
          
          let { data } = await axios({ 
            url, 
            method: 'POST', 
            headers: { Authorization: 'Bearer ' + token },
            data: requestData
          })

          this.shares = data
          return
        } catch (error) {
          this.error = error.message
          return
        }
      },
      closeDialog () {
        this.$refs.form.reset()
        this.dialog = false
      }
    }
  }

</script>

<style lang="scss" scoped>

</style>